import HeroSection from './components/HeroSection';
import CategoryTabs from './components/CategoryTabs';
import FeaturedSection from './components/FeaturedSection';
import HotRanking from './components/HotRanking';
import LatestUpdates from './components/LatestUpdates';

const homepageSchema = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  name: '韩漫之家',
  url: 'https://hanmanzhijia.com',
  description: '韩漫之家提供免费阅读韩国漫画的服务，涵盖韩漫在线和韩漫大全，海量韩国漫画资源，流畅阅读体验。',
  potentialAction: {
    '@type': 'SearchAction',
    target: 'https://hanmanzhijia.com/search?q={search_term_string}',
    'query-input': 'required name=search_term_string',
  },
  inLanguage: 'zh-CN',
};

const orgSchema = {
  '@context': 'https://schema.org',
  '@type': 'Organization',
  name: '韩漫之家',
  url: 'https://hanmanzhijia.com',
  description: '韩国漫画免费阅读首选平台',
  email: 'contact@hanmanzhijia.com',
  telephone: '400-888-6688',
  address: {
    '@type': 'PostalAddress',
    streetAddress: '望京SOHO T1-1208',
    addressLocality: '北京',
    addressRegion: '朝阳区',
    addressCountry: 'CN',
  },
};

export default function Home() {
  return (
    <>
      <script type="application/ld+json">{JSON.stringify(orgSchema)}</script>
      <script type="application/ld+json">{JSON.stringify(homepageSchema)}</script>
      <main>
        <HeroSection />
        <CategoryTabs />
        <FeaturedSection />
        <HotRanking />
        <LatestUpdates />
      </main>
    </>
  );
}